export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14883.e24e9bf0.jpg";